require('../blockStep.scss');
require('./blockStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ actions
const cardBlockActions = require('actions/cardBlockActions');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const personalDataHelper = require('utilities/personalDataHelper');
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');
// @ components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { InputSafe } = require('commonsComponents/inputSafe');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKMessage } = require('commonsComponents/OKMessage');
// @constants
const { ACTION_EVENT_VIEW, MAESTRO_CARD_EVENT, MAESTRO_BLOCK_CARD_LINK } = require('constants/tagging');
const {CARD_BLOCK_REASON_LOSS, CARD_BLOCK_REASON_THEFT} = require('constants/index');
const {
    METALLIC_CARD
} = require('constants/flagBasedFeatures');
// @utils
const { recordLinkV2 } = require("utilities/tagging");


class BlockStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.handleCardReplaceChange = this.handleCardReplaceChange.bind(this);
        this.handleMotiveChange = this.handleMotiveChange.bind(this);
        this.handleCommentsChange = this.handleCommentsChange.bind(this);
    }

    isMaestroNL() {
        const { immProfile } = this.props;
        return immProfile.get('originCountry').toUpperCase() === 'NL';
    }

    buildAddressBlock(){
        const { cardReplace, immProfile } = this.props;
        let addressBlock;
        const maestroCard = this.isMaestroNL();
        if(maestroCard && cardReplace){
            const taggingData = {
                    categoriaEvento: MAESTRO_BLOCK_CARD_LINK,
                    accionEvento: MAESTRO_CARD_EVENT,
                    etiquetaEvento: ACTION_EVENT_VIEW,
                    nombrePagina: MAESTRO_BLOCK_CARD_LINK
                }
                recordLinkV2(taggingData)     
             } 

        if (cardReplace) {
            const registeredAddress = personalDataHelper.getFormattedAddress(immProfile);

            addressBlock = (
                <div className="block-step__address">
                    {maestroCard &&
                        <p>
                            <OKMessage type="important">
                                <FormattedText value="cardReplace-newCardWarningMessage" />
                            </OKMessage>
                        </p>
                    }
                    <FormattedText value="cardBlock-sendingAddress" />
                    <OKTooltip
                        content="cardBlock-sendingAddressTooltip"
                        offset={[15, 0]}
                        placement="right"
                    />
                    <br/>
                    <strong>{registeredAddress}</strong>
                </div>
            );
        }

        return addressBlock;
    }

    buildReplaceFieldset(){
        const { cardReplace, immCard, immFlagBasedFeatures } = this.props;
        let replaceFieldset;
        let isR42cardValidType = immCard.get('isMetallic');   
        // If the selected card allows replacement requests via web, we show a checkbox
        if (cardValidationRules.CARD_REPLACE.validator({immCard})) {
            const addressBlock = this.buildAddressBlock();
            const checkboxLabel = (
                <div>
                    <FormattedText
                        className="block-step__subtitle block-step__subtitle--inline"
                        value="cardBlock-requestNewCardPart1"
                    />
                    <FormattedText value="cardBlock-requestNewCardPart2" />
                </div>
            );
            replaceFieldset = (
                <fieldset>
                    {((__CONTACT_CENTER__ && (immCard.get('isVirtualCredit') || immCard.get('isVirtualDebit'))) || ((immFlagBasedFeatures.get(METALLIC_CARD) && isR42cardValidType) || (!isR42cardValidType))) && 
                        <OKCheckbox
                        extraClass="block-step__checkbox"
                        idName="chk_BlockStep1_CardReplace"
                        label={checkboxLabel}
                        onChange={this.handleCardReplaceChange}
                        value={cardReplace}
                    />}
                    {!(immCard.get('isVirtualCredit') || immCard.get('isVirtualDebit')) && addressBlock}
                </fieldset>
            );
        }

        return replaceFieldset;
    }

    handleCardReplaceChange(evt) {
        this.props.setCardReplace(evt.target.checked);
    }

    handleCommentsChange(evt) {
        this.props.setComments(evt.target.value);
    }

    handleMotiveChange(value) {
        this.props.setMotive(value);
    }

    render() {
        const { comments, motive } = this.props;
        const replaceFieldset = this.buildReplaceFieldset();
        const radio1Label = formatText('cardBlock-theft');
        const radio2Label = formatText('cardBlock-loss');

        return (
            <article className="block-step block-step--one">
                <header className="block-step__header">
                    <FormattedText value="cardBlock-blockingMotive" className="block-step__title" />
                </header>
                <section className="block-step__content">
                    <form>
                        <fieldset>
                            <FormattedText value="cardBlock-selectMotive" className="block-step__subtitle block-step--subtitle-more-margin" />

                            <RadioButtonGroup
                                name="motive"
                                idPrefix="motiveRadio"
                                selectedValue={motive}
                                onChange={this.handleMotiveChange}
                                className="block-step__radio-group"
                            >
                                <RadioButton label={radio1Label} value={CARD_BLOCK_REASON_THEFT} className="block-step__radio"/>
                                <RadioButton label={radio2Label} value={CARD_BLOCK_REASON_LOSS} className="block-step__radio"/>
                            </RadioButtonGroup>
                        </fieldset>
                        <fieldset>
                            <InputSafe
                                value={comments}
                                horizontalResize={true}
                                label={formatText('cardBlock-comments')}
                                onChange={this.handleCommentsChange}
                                isTextArea={true}
                            />
                        </fieldset>
                        {replaceFieldset}
                    </form>
                </section>
            </article>
        )
    }
}

BlockStep1.propTypes = {
    cardReplace: PropTypes.bool,
    comments: PropTypes.string,
    immCard: PropTypes.object,
    immProfile: PropTypes.object,
    motive: PropTypes.string,
    setCardReplace: PropTypes.func.isRequired,
    setComments: PropTypes.func,
    setMotive: PropTypes.func,
    immFlagBasedFeatures: PropTypes.object,
};

module.exports.constructor = BlockStep1;
module.exports.BlockStep1 = connect(
   null,
    {
        setCardReplace: cardBlockActions.setCardReplace,
        setComments: cardBlockActions.setComments,
        setMotive: cardBlockActions.setMotive,
    }
)(BlockStep1);